<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.95083 2.30557C6.9487 2.30555 6.94657 2.30554 6.94444 2.30554C6.94231 2.30554 6.94017 2.30555 6.93804 2.30557H4.16667C2.52515 2.30557 1.19444 3.63628 1.19444 5.27779V14.7222C1.19444 16.3637 2.52515 17.6945 4.16667 17.6945H15.8333C17.4748 17.6945 18.8056 16.3637 18.8056 14.7222V5.27779C18.8056 3.63628 17.4748 2.30557 15.8333 2.30557H6.95083ZM6.19444 3.80557H4.16667C3.35358 3.80557 2.69444 4.4647 2.69444 5.27779V14.7222C2.69444 15.5353 3.35358 16.1945 4.16667 16.1945H6.19444V3.80557ZM7.69444 16.1945V3.80557H15.8333C16.6464 3.80557 17.3056 4.4647 17.3056 5.27779V14.7222C17.3056 15.5353 16.6464 16.1945 15.8333 16.1945H7.69444Z"
            fill="#8E8E93"
        />
    </svg>
</template>
